export interface ResolveHomeAvulsoBackdropInput {
  skipBackdrops: boolean;
  hasFinishedInitialConsultation: boolean;
  isLoading: boolean;
  hasStartedConsultation: boolean;
  alreadyHandled: boolean;
  debtsCount: number;
  isAvulsoFlow: boolean;
}

export interface ResolveHomeAvulsoBackdropResult {
  hasFinishedInitialConsultation: boolean;
  showBackdrop: boolean;
  alreadyHandled: boolean;
}

export function resolveHomeAvulsoBackdrop({
  skipBackdrops,
  hasFinishedInitialConsultation,
  isLoading,
  hasStartedConsultation,
  alreadyHandled,
  debtsCount,
  isAvulsoFlow,
}: ResolveHomeAvulsoBackdropInput): ResolveHomeAvulsoBackdropResult {
  if (skipBackdrops) {
    return {
      hasFinishedInitialConsultation,
      showBackdrop: false,
      alreadyHandled: true,
    };
  }

  if (!hasStartedConsultation) {
    return {
      hasFinishedInitialConsultation: false,
      showBackdrop: false,
      alreadyHandled,
    };
  }

  if (alreadyHandled) {
    return {
      hasFinishedInitialConsultation: !isLoading,
      showBackdrop: false,
      alreadyHandled: true,
    };
  }

  if (debtsCount > 0 && isAvulsoFlow) {
    return {
      hasFinishedInitialConsultation: !isLoading,
      showBackdrop: true,
      alreadyHandled: true,
    };
  }

  if (isLoading) {
    return {
      hasFinishedInitialConsultation: false,
      showBackdrop: false,
      alreadyHandled,
    };
  }

  return {
    hasFinishedInitialConsultation: true,
    showBackdrop: false,
    alreadyHandled: false,
  };
}
